import {tween} from "@fae/source/engine/animating/utility/Tweens.js"

// a <Point>
// b <Point>
// progress <Number> between 0 and 1
export function arc(height) {
    return (a, b, progress) => {
        a.x = a.x || 0
        a.y = a.y || 0
        a.z = a.z || 0
        b.x = b.x || 0
        b.y = b.y || 0
        b.z = b.z || 0
        const distance = {
            "x": b.x - a.x,
            "y": b.y - a.y,
            "z": b.z - a.z,
        }
        // const direction = {
        //     "x": Math.sign(distance.x),
        //     "y": Math.sign(distance.y),
        //     "z": Math.sign(distance.z),
        // }
        const midpoint = {
            "x": a.x + (distance.x / 2),
            "y": a.y + (distance.y / 2),
            "z": a.z + (distance.z / 2),
        }
        // const diameter = Math.sqrt((distance.x * distance.x) + (distance.y * distance.y))
        const angle = Math.atan2(distance.y, distance.x)
        const diameter = Math.hypot(distance.x, distance.y)
        const radius = {
            "h": (diameter / 2),
            "v": height || 1.25, // TODO: Shouldn't this be variable for the longer arcs?
        }
        const degree = (progress * Math.PI) - (Math.PI / 2)

        // if(sizes.camera.type == "isometric") {
        //     return {
        //         "x": midpoint.x + (Math.sin(degree) * radius.h * Math.cos(angle)),
        //         "y": midpoint.y + (Math.sin(degree) * radius.h * Math.sin(angle)),
        //         "z": midpoint.z + 0.1 + (Math.cos(degree) * radius.v),
        //     }
        // } else {
        return {
            "x": midpoint.x + (Math.sin(degree) * radius.h * Math.cos(angle)),
            "y": midpoint.y + (Math.sin(degree) * radius.h * Math.sin(angle)) - (Math.cos(degree) * radius.v),
            // "z": midpoint.z + 0.1 + (Math.cos(degree) * radius.v),
            "z": midpoint.z
        }
    }
}

// a <Point>
// b <Point>
// progress <Number> between 0 and 1
export function line(a, b, progress) {
    a.x = a.x || 0
    a.y = a.y || 0
    a.z = a.z || 0
    b.x = b.x || 0
    b.y = b.y || 0
    b.z = b.z || 0
    return {
        "x": tween(a.x, b.x, progress),
        "y": tween(a.y, b.y, progress),
        "z": tween(a.z, b.z, progress),
    }
}
